import { DecorItemI } from "../../../shared";

export const updateDecor = (decorItem: Partial<DecorItemI>, decors: DecorItemI[]) => {
    const updateDecors = [...decors];
    const index = decors.findIndex((decor) => decor.id === decorItem.id);

    // Если переданный декор не содержит triangularPrism, а исходный содержит,
    // то мы должны его удалить (для корректного сброса призмы)
    const originalDecor = decors[index];
    const hasTriangularPrismInOriginal = !!originalDecor.triangularPrism;
    const hasTriangularPrismInUpdate = 'triangularPrism' in decorItem;

    let updatedDecor = {
        ...originalDecor,
        ...decorItem,
    };

    // Если в обновлении нет triangularPrism, но в оригинале есть, удаляем его
    if (hasTriangularPrismInOriginal && !hasTriangularPrismInUpdate) {
        const { triangularPrism, ...decorWithoutPrism } = updatedDecor;
        updatedDecor = decorWithoutPrism;
    }

    updateDecors[index] = updatedDecor;
    return updateDecors;
};
